import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {distinctUntilChanged, filter, switchMap, takeUntil} from 'rxjs/operators';
import {UserRoles} from '../../../shared/constants/user-roles.constant';
import {SubstituteService} from '../../../shared/services/substitute.service';
import type {SubstituteScope} from '../../../reducers/substitute/substitute.reducer';
import {Substitute} from '../../../shared/models/substitute.model';

@Component({
  selector: 'app-substitutes',
  templateUrl: './substitutes.component.html',
  styleUrls: ['./substitutes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubstitesComponent implements OnDestroy {
  private ngUnsubscribe = new Subject<void>();
  private scopeSubject = new BehaviorSubject<SubstituteScope>('my');
  displayedColumns = ['substituteUser', 'user', 'startDate', 'endDate', 'actions'];
  testId = 'substitutes';

  substitutes$: Observable<Substitute[]>;
  loading$: Observable<boolean>;
  get scope(): SubstituteScope {
    return this.scopeSubject.value;
  }
  set scope(scope: SubstituteScope) {
    this.scopeSubject.next(scope);
    this.cd.detectChanges();
  }
  UserRoles = UserRoles;

  constructor(private substituteService: SubstituteService, public cd: ChangeDetectorRef) {
    this.loading$ = this.substituteService.loading$();

    this.substitutes$ = this.scopeSubject.asObservable().pipe(
      distinctUntilChanged(),
      switchMap(scope =>
        this.substituteService.load$(scope).pipe(
          filter(i => !!i),
          takeUntil(this.ngUnsubscribe)
        )
      )
    );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
